import React from "react";
import { Form } from "@ant-design/compatible";
import "@ant-design/compatible/assets/index.css";
import { Input, Button } from "antd";
import { withRouter } from "react-router";

function InputName(props) {
  const handleInput = (e) => {
    e.preventDefault();
    props.form.validateFields((err, values) => {
      if (!err) {
        const { name } = values;
        props.changeName(name);
        props.history.push("/WeChat/management/add/scanCode");
      }
    });
  };

  const { getFieldDecorator } = props.form;

  return (
    <Form
      style={{ display: "flex", justifyContent: "center" }}
      layout="inline"
      labelCol={{
        sm: { span: 4 },
      }}
      wrapperCol={{
        sm: { span: 20 },
      }}
      onSubmit={handleInput}
    >
      <Form.Item label="用户名" help="设置一个用户名，方便记忆和管理">
        {getFieldDecorator("name", {
          rules: [
            {
              required: true,
              message: "请先输入用户名",
            },
          ],
        })(<Input addonBefore="子账号_" className="input-wrapper" placeholder="请输入" style={{ width: 300 }} />)}
      </Form.Item>
      <Form.Item>
        <div className="btn-wrapper">
          <Button type="primary" htmlType="submit">
            下一步
          </Button>
        </div>
      </Form.Item>
    </Form>
  );
}
const WrapperInputNameForm = Form.create({})(InputName);
export default withRouter(WrapperInputNameForm);
